import { Box } from '@material-ui/core';
import React from 'react';

import { CopyToClipboardButton } from '@/components/shared/components/CopyToClipboardButton';
import { Font } from '@/components/shared/components/Font';
import { useCustomTheme } from '@/hooks/useCustomTheme';

const OverviewDetailRow = ({
  field,
  value,
  copyButton,
  boxProps,
}: {
  field: string | React.ReactElement;
  value: string | number | React.ReactElement | null;
  copyButton?: boolean;
  boxProps?: React.ComponentProps<typeof Box>;
}) => {
  const { palette } = useCustomTheme();

  return (
    <Box display={'inline-flex'} justifyContent={'flex-start'} alignItems={'center'} minHeight={'26px'} {...boxProps}>
      <div style={{ maxWidth: '100%' }} className={'overflow-text-ellipsis'}>
        <Font variant="body2" color="textSecondary" style={{ marginRight: '8px' }}>
          {field}
        </Font>
        <Font variant="subtitle2" color="textSecondary" style={{ marginRight: '4px' }}>
          {value ?? '-'}
        </Font>
      </div>
      {copyButton && value && (
        <CopyToClipboardButton style={{ color: palette.text.secondary }} value={value.toString()} />
      )}
    </Box>
  );
};

export { OverviewDetailRow };
